export const RECEIVE_WIRE_DISTRIBUTIONS = 'RECEIVE_WIRE_DISTRIBUTIONS';
export const GET_WIRE_DISTRIBUTIONS = 'GET_WIRE_DISTRIBUTIONS';
export const SET_WIRE_DISTRIBUTION = 'SET_WIRE_DISTRIBUTION';
export const UPDATE_WIRE_DISTRIBUTION = 'UPDATE_WIRE_DISTRIBUTION';
export const DELETE_WIRE_DISTRIBUTION = 'DELETE_WIRE_DISTRIBUTION';
export const FETCH_WIRE_DISTRIBUTIONS = 'FETCH_WIRE_DISTRIBUTIONS';
